export function debounce(fn, ms) {
  let timeout = null;

  return function (...args) {
    clearTimeout(timeout);

    // necessary in order to apply callback function to vue instance
    const self = this;

    timeout = setTimeout(function () {
      fn.apply(self, args);
    }, ms);
  };
}
